import { Typography } from "@mui/material";
import dayjs from "dayjs";
import { PrescriptionResponseDtoStatusEnum } from "libs/cellera-sdk";
import { useMemo } from "react";

import { PrescriptionCard } from "./PrescriptionCard";
import { StatusTag } from "./StatusTag";

export interface IPrescriptionOrderInformationCardProps {
  orderId: string;
  status?: PrescriptionResponseDtoStatusEnum;
  createdAt?: Date;
  paidAt?: Date;
  cancelledAt?: Date;
}

export const PrescriptionOrderInformationCard = ({
  orderId,
  status,
  createdAt,
  paidAt,
  cancelledAt,
}: IPrescriptionOrderInformationCardProps) => {
  const persistedStyle = useMemo(
    () => ({
      className: "break-words",
      sx: { fontWeight: 600 },
    }),
    []
  );
  const orderInformation = useMemo(
    () => [
      {
        label: "Order ID",
        value: <Typography {...persistedStyle}>{orderId}</Typography>,
      },
      {
        label: "Status",
        value: status ? <StatusTag status={status} /> : "N/A",
      },
      {
        label: "Created at",
        value: createdAt ? (
          <Typography {...persistedStyle}>
            {dayjs(createdAt).format("MMM DD, YYYY HH:mm")}
          </Typography>
        ) : (
          "N/A"
        ),
      },
      {
        label: "Paid at",
        value: (
          <Typography {...persistedStyle}>
            {paidAt ? dayjs(paidAt).format("MMM DD, YYYY HH:mm") : "N/A"}
          </Typography>
        ),
      },
      {
        label: "Cancelled at",
        value: (
          <Typography {...persistedStyle}>
            {cancelledAt
              ? dayjs(cancelledAt).format("MMM DD, YYYY HH:mm")
              : "N/A"}
          </Typography>
        ),
      },
    ],
    [cancelledAt, createdAt, orderId, paidAt, persistedStyle, status]
  );
  return (
    <PrescriptionCard title="Order Information" items={orderInformation} />
  );
};
